import mrApi from './mrApi';

export default {
  getByTopics
};

export function getByTopics(params) {
  return mrApi.get('/api/siteMessages/getByTopics', { params });
}
